export default "__VITE_ASSET__4aB3QD_B__"